module.exports = __webpack_public_path__ + "img/Logo.1f31e301.png";